import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule, Optional, SkipSelf } from "@angular/core";
import { IntlModule as KendoIntlModule } from "@progress/kendo-angular-intl";
import { MessageService } from "@progress/kendo-angular-l10n";

import { API_CONFIG, ApiConfig, AppInitializerService, AuthInterceptor, XsrfInterceptor, appInitializerFactory } from "@jwt";
import { HeaderComponent } from "./component/header/header.component";
import { CustomMessagesService } from "./services/custom-messages.service";

import '@progress/kendo-angular-intl/locales/en/all';
import '@progress/kendo-angular-intl/locales/el/all';
import '@progress/kendo-angular-intl/locales/fr/all';
import '@progress/kendo-angular-intl/locales/de/all';
import '@progress/kendo-angular-intl/locales/ru/all';
import { ClientDataService } from "@toolkit";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        KendoIntlModule, // not remove
    ],
    exports: [
        // components that are used in app.component.ts will be listed here.
        HeaderComponent
    ],
    declarations: [
        // components that are used in app.component.ts will be listed here.
        HeaderComponent
    ],

    providers: [
        /* ``No`` global singleton services of the whole app should be listed here anymore!
           Since they'll be already provided in AppModule using the `tree-shakable providers` of Angular 6.x+ (providedIn: 'root').
           This new feature allows cleaning up the providers section from the CoreModule.
           But if you want to provide something with an InjectionToken other that its class, you still have to use this section.
        */
        {
            provide: API_CONFIG,
            useValue: ApiConfig
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: XsrfInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: appInitializerFactory,
            deps: [AppInitializerService],
            multi: true
        },
        { provide: MessageService, useClass: CustomMessagesService },
        { provide: LOCALE_ID, useValue: "en-US" },
        ClientDataService
    ]
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() core: CoreModule) {
        if (core) {
            throw new Error("CoreModule should be imported ONLY in AppModule.");
        }
    }
}
